Tracking = function( dispatcher ) {
	/*---------------------------------------------------
		VARIABLES 
	--------------------------------------------------*/
	
	this.dispatcher = ( dispatcher !== undefined ) ? dispatcher : new Dispatcher();
	
	/*--------------------------------------------------*/
	
	this.init();

};

Tracking.prototype = {

	constructor : Tracking,
	

	/*-------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/
	init : function(){
		this.bindEvents();
	},
	
	bindEvents : function(){
		this.dispatcher.addEventListener( EVENTS.TRACKING, this.onTrackEvent.bind( this ) );
		this.dispatcher.addEventListener( EVENTS.TRACKING_PAGE, this.onTrackEventPageRaw.bind( this ) );
		this.dispatcher.addEventListener( EVENTS.TRACKING_PAGE_EXTRA, this.onTrackEventPageExtra.bind( this ) );
		this.dispatcher.addEventListener( EVENTS.TRACKING_CLICK, this.onTrackClick.bind( this ) );
		this.dispatcher.addEventListener( EVENTS.TRACKING_CLICKBUY, this.onTrackClickBuy.bind( this ) );
		this.dispatcher.addEventListener( EVENTS.TRACKING_VIDEO, this.onTrackVideo.bind( this ) );
	},

	/*-------------------------------------------------
		EVENT HANDLERS
	--------------------------------------------------*/
	onTrackEventPageExtra : function( event , data ){

		var type = localisation.site.tracking.actions.page.ExtraContent + encodeURI(data) + ".html";
		
		this.onTrackPage (  { code : type } );
	},

	onTrackEventPageRaw : function(event , page){

		var ref = localisation.site.tracking.actions.page
		var track = undefined;
		switch( page ){
			case "recieved" :  track = "recieved" ; break;
			case "explore" : track = "explore" ; break;
			case "write" : track = "writeMessage" ;  break;
			case "preview" : track = "previewMessage" ; break;
			case "share" : track = "share" ;  break;
			case "ExtraContent" : track = "ExtraContent" ; break;
		}
		if(track){
			this.onTrackPage (  {code : ref[track]} );
		}
		
	},

	onTrackEvent : function( event , tracking ){
		switch( tracking.type ){

			case "click" : this.onTrackClick( tracking ); break;
			case "clickBuy" : this.onTrackClickBuy( tracking ); break;
			case "pageView" : this.onTrackPage( tracking ); break;
			

		}
	},
	
	onTrackClickBuy : function(e, data ){
		sCode.trackOutboundClickToBuy( 'targetURL', data );
	},

	onTrackClick : function( e,data ){
		sCode.trackOutboundClick( 'targetURL' , data );
	},

	onTrackPage : function(data){
		console.log(data.code)
		sCode.trackPageView( data.code );
	},

	onTrackVideo : function( event , data){
		console.log("video"+ data)
		sCode.trackVideo( data, "start" );
	}

};


